import React, { useEffect, useState } from "react";
import CampusComments from "./CampusComments";
import QAThread from "./qa/QAThread";
import { supabase } from "../../lib/supabase";

const PostModalManager = ({ 
  activePostId, 
  onClose, 
  currentUser, 
  onViewProfile 
}) => {
  const [postType, setPostType] = useState(null); // 'qa' or 'feed'
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchPostType = async () => {
      if (!activePostId) {
        setPostType(null);
        return;
      }

      setLoading(true);
      const { data, error } = await supabase
        .from("posts")
        .select("community_id")
        .eq("id", activePostId)
        .single();
      
      if (!error && data) {
        setPostType(data.community_id === 2 ? 'qa' : 'feed');
      } else {
        setPostType(null);
      }
      setLoading(false);
    };

    fetchPostType();
  }, [activePostId]);

  if (!activePostId) return null;

  if (loading) return null; // Or a subtle loader

  // Case 1: Standard post (Feed, Confessions, etc.)
  if (postType === 'feed') {
    return (
      <CampusComments
        postId={activePostId}
        onClose={onClose}
        currentUser={currentUser}
        showPost={true} // New prop to show full post at top
        onViewProfile={(uid) => {
          onClose();
          onViewProfile && onViewProfile(uid);
        }}
      />
    );
  }

  // Case 2: QA thread
  if (postType === 'qa') {
    return (
      <QAThread
        questionId={activePostId}
        onClose={onClose}
        currentUser={currentUser}
        onViewProfile={(uid) => {
          onClose();
          onViewProfile && onViewProfile(uid);
        }}
      />
    );
  }

  return null;
};

export default PostModalManager;
